export default __webpack_public_path__ + "static/health-claims-healthcare-ee707b5e214b906556228a49e8d468fc.png";